import Helmet from 'react-helmet-async';
import * as React from 'react';
import {isStringEmpty} from '../string/is-string-empty.util';
import {inject} from 'mobx-react';
import {IInjectedProps} from '../../interface/component/injected-props.interface';

export interface ICustomFontsInclusionsProps {
  html?: string;
  fontsList?: string[];
  includeAll?: boolean;
}

const isFontUsedInHtml = (html: string, fontName: string): boolean => {
  return !isStringEmpty(html) && html.indexOf(`font-family: ${fontName}`) > -1;
};

function isFontOccurring(fontsList: string[], fontName: string): boolean {
  return fontsList && fontsList.some(u => u.indexOf(fontName) === 0);
}

export const CustomFontsInclusions = inject('state')((props: ICustomFontsInclusionsProps & IInjectedProps) => {
  let customFontsInclusions = [];
  if (props.state.configuration.customFonts) {
    const usedCustomFonts = props.includeAll ?
      props.state.configuration.customFonts :
      props.state.configuration.customFonts.filter(x => isFontUsedInHtml(props.html, x.fontName) || isFontOccurring(props.fontsList, x.fontName));
    customFontsInclusions = usedCustomFonts.map(x =>
      <style key={x.id} data-type="custom-font-style">
        {`@font-face {
          font-family: '${x.fontName}';
          font-style: normal;
          font-weight: 400;
          font-display: swap;
          src: local('${x.fontName}'), local('${x.fontName} Regular'), local('${x.fontName}-Regular'), url(${x.fontUrl}) format('woff2');
        }`}
      </style>);
  }
  const isGoogleFontUsed = props.includeAll ?
    true :
      props.state.configuration.googleFonts &&
      (props.state.configuration.googleFonts.fonts.some(x => isFontUsedInHtml(props.html, x.fontName)) ||
      props.state.configuration.googleFonts.fonts.some(x => isFontOccurring(props.fontsList, x.fontName)));

  return <Helmet>
    {customFontsInclusions}
    {isGoogleFontUsed && <link key="google-fonts-url-key" data-type="google-fonts-url" href={props.state.googleFontsUrl} rel="stylesheet" />}
  </Helmet>;
});